var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import "core-js";
import React from "react";
import { ReactReduxContext, connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { ChatContext } from "./Context.js";
import ApisClient from "./utils/api.js";
class Provider extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { chatConfig } = this.props;
    this.config = chatConfig;
    this.apiClient = new ApisClient(this.config);
    this.contextValue = {
      state: this.props.state,
      apiClient: this.apiClient,
      chatConfiguration: this.config
    };
  }
  render() {
    return /* @__PURE__ */ jsx(ChatContext.Provider, { value: this.contextValue, children: this.props.children });
  }
}
__publicField(Provider, "contextType", ReactReduxContext);
Provider.propTypes = {
  state: PropTypes.object,
  chatConfig: PropTypes.object.isRequired,
  children: PropTypes.node
};
const mapStateToProps = (state, ownProps) => ({
  state: state[ownProps.prefix]
});
const ReduxifyProvider = compose(connect(mapStateToProps, null))(Provider);
ReduxifyProvider.defaultProps = {
  prefix: "chat"
};
export {
  ReduxifyProvider as default
};
//# sourceMappingURL=Provider.js.map
